module.exports = __webpack_public_path__ + "static/media/carusele_section_bcg.226e70a9.png";